import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { EsqueciSenhaComponent } from './features/esqueci-senha/esqueci-senha.component';
import { AtualizarSenhaComponent } from './features/atualizar-senha/atualizar-senha.component';
import { HomeComponent } from './features/home/home.component';
import { usuarioAutenticadoGuard } from './core/guards/usuario-autenticado.guard';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { ListaPedidosComponent } from './features/lista-pedidos/lista-pedidos.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { NovoPedidoComponent } from './features/novo-pedido/novo-pedido.component';

const routes: Routes = [
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  { path: '', component: LoginComponent },
  { path: ':chave', component: LoginComponent },
  {
    path: 'oticomlab', component: HomeComponent, canActivate: [usuarioAutenticadoGuard], children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'pedidos', component: ListaPedidosComponent },
      { path: 'atualizar-senha', component: AtualizarSenhaComponent },
      { path: 'pedido-laboratorio', component: NovoPedidoComponent },
      { path: 'pedido-laboratorio/:pedido_lab/:id', component: NovoPedidoComponent },
      { path: 'pedido-atacado', component: NovoPedidoComponent },
      { path: 'pedido-atacado/:pedido_lab/:id', component: NovoPedidoComponent },
    ]
  },
  { path: '**', component: NotFoundComponent },

  // {
  //   path: '', component: HomeComponent, children: [
  //     { path: '', component: LoginComponent },
  //     { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  //     { path: 'dashboard', component: DashboardComponent },
  //     { path: 'pedidos', component: ListaPedidosComponent },
  //     { path: 'atualizar-senha', component: AtualizarSenhaComponent },
  //     // { path: ':chave', component: LoginComponent },
  //   ],
  // },
  // { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
